/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "../../../core/services/translate.service";

@Pipe({
   standalone: false,
   name: "languageLayoutSearch"
})
export class LanguageLayoutSearchPipe implements PipeTransform {
   constructor(private translate: TranslateService) {}
   transform(layouts, language, query) {
      const textContainsQuery = (text, query) => {
         if (query === "") {
            return true;
         }
         return text.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) !== -1;
      };
      const getSearchResult = (layout) => {
         if (
            textContainsQuery(this.translate._T(language), query) ||
            textContainsQuery(this.translate._T(layout), query)
         ) {
            return true;
         } else {
            return false;
         }
      };
      return layouts.filter(getSearchResult);
   }
}
